import { DrawerOverlay } from "@chakra-ui/react";
import { assertNever } from "@syla/shared/types/helpers/errors";
import { PopulatedWallet } from "@syla/shared/types/models/WalletBase";
import React, { useState } from "react";
import { AppDrawer } from "../../../AppDrawer";
import { AppDrawerContent } from "../../../modals/AppDrawerContent";
import { EditDataSourceWorkflow } from "../workflows/EditDataSourceWorkflow";

import { FileImportWorkflow } from "../workflows/FileImportWorkflow";

export type EditDataSourceMode = "edit" | "fileImport";

export function EditDataSourceDrawer({
  isOpen,
  onClose,
  wallet,
  editMode,
}: {
  isOpen: boolean;
  onClose: () => void;
  wallet: PopulatedWallet;
  editMode: EditDataSourceMode;
}): React.ReactElement {
  const [allowQuickClose, setAllowQuickClose] = useState(true);

  return (
    <AppDrawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      size="sm"
      closeOnOverlayClick={allowQuickClose}
      closeOnEsc={allowQuickClose}
    >
      <DrawerOverlay />
      <AppDrawerContent>
        <EditDataSourceSwitch
          wallet={wallet}
          editMode={editMode}
          onClose={onClose}
          setAllowQuickClose={setAllowQuickClose}
        />
      </AppDrawerContent>
    </AppDrawer>
  );
}

function EditDataSourceSwitch({
  wallet,
  editMode,
  onClose,
  setAllowQuickClose,
}: {
  wallet: PopulatedWallet;
  editMode: EditDataSourceMode;
  onClose: () => void;
  setAllowQuickClose: (value: boolean) => void;
}): React.ReactElement {
  if (editMode === "edit") {
    return <EditDataSourceWorkflow wallet={wallet} onBack={onClose} />;
  }

  if (editMode === "fileImport") {
    return (
      <FileImportWorkflow
        wallet={wallet}
        onClose={onClose}
        setAllowQuickClose={setAllowQuickClose}
      />
    );
  }

  assertNever(editMode);
}
